
export class WidgetSelect {
k: string;
v: string;
}

